module.exports = __webpack_public_path__ + "static/media/logo-consulenze.a8d0ace8.png";